export const changeTempReportToFahrenheit = report => {
  let temp = { ...report };

  temp.UnidadTemperatura = 1;
  temp.Resultados = temp.Resultados.map(r => {
    let resultado = Object.assign({}, r);
    resultado.TemperaturaMinima = celsiusToFahrenheit(r.TemperaturaMinima);

    resultado.TemperaturaMaxima = celsiusToFahrenheit(r.TemperaturaMaxima);

    resultado.CiclosRefrigeracion = r.CiclosRefrigeracion.map(c => {
      let ciclo = Object.assign({}, c);
      ciclo.TemperaturaMinima = celsiusToFahrenheit(c.TemperaturaMinima);
      ciclo.TemperaturaMaxima = celsiusToFahrenheit(c.TemperaturaMaxima);
      ciclo.TemperaturaPromedio = celsiusToFahrenheit(c.TemperaturaPromedio);
      ciclo.UbicacionInicio = Object.assign({}, c.UbicacionInicio);
      ciclo.UbicacionInicio.temperatura = celsiusToFahrenheit(
        c.UbicacionInicio.temperatura
      );

      ciclo.UbicacionInicio.sensoresTemperatura = c.UbicacionInicio.sensoresTemperatura.map(
        s => {
          let sensor = celsiusToFahrenheit(s);
          return sensor;
        }
      );

      ciclo.UbicacionFin = Object.assign({}, c.UbicacionFin);
      ciclo.UbicacionFin.temperatura = celsiusToFahrenheit(
        c.UbicacionFin.temperatura
      );
      ciclo.UbicacionFin.sensoresTemperatura = c.UbicacionFin.sensoresTemperatura.map(
        s => {
          let sensor = celsiusToFahrenheit(s);
          return sensor;
        }
      );
      return ciclo;
    });

    resultado.IntervalosFueraRango = r.IntervalosFueraRango.map(i => {
      let intervalo = Object.assign({}, i);

      intervalo.Rango = Object.assign({}, i.Rango);
      intervalo.Rango.LimiteInferior = celsiusToFahrenheit(
        i.Rango.LimiteInferior
      );
      intervalo.Rango.LimiteSuperior = celsiusToFahrenheit(
        i.Rango.LimiteSuperior
      );
      intervalo.TemperaturaMinima = celsiusToFahrenheit(i.TemperaturaMinima);
      intervalo.TemperaturaMaxima = celsiusToFahrenheit(i.TemperaturaMaxima);
      intervalo.TemperaturaPromedio = celsiusToFahrenheit(
        i.TemperaturaPromedio
      );
      return intervalo;
    });

    resultado.EventosTemp = r.EventosTemp.map(e => {
      let evento = Object.assign({}, e);
      evento.temperatura = celsiusToFahrenheit(e.temperatura);
      evento.sensoresTemperatura = e.sensoresTemperatura.map(s => {
        let sensor = celsiusToFahrenheit(s);
        return sensor;
      });
      return evento;
    });

    resultado.Ubicaciones = r.Ubicaciones.map(u => {
      let ubicacion = Object.assign({}, u);
      ubicacion.temperatura = celsiusToFahrenheit(u.temperatura);
      ubicacion.sensoresTemperatura = u.sensoresTemperatura.map(s => {
        let sensor = celsiusToFahrenheit(s);
        return sensor;
      });
      return ubicacion;
    });

    return resultado;
  });

  return temp;
};

export const changeTempReportToCelsius = report => {
  let temp = { ...report };
  temp.UnidadTemperatura = 0;

  temp.Resultados.forEach(resultado => {
    resultado.TemperaturaMinima = fahrenheitToCelsius(
      resultado.TemperaturaMinima
    );

    resultado.TemperaturaMaxima = fahrenheitToCelsius(
      resultado.TemperaturaMaxima
    );

    resultado.CiclosRefrigeracion.forEach(ciclo => {
      ciclo.TemperaturaMinima = fahrenheitToCelsius(ciclo.TemperaturaMinima);
      ciclo.TemperaturaMaxima = fahrenheitToCelsius(ciclo.TemperaturaMaxima);
      ciclo.TemperaturaPromedio = fahrenheitToCelsius(
        ciclo.TemperaturaPromedio
      );
      ciclo.UbicacionInicio.temperatura = fahrenheitToCelsius(
        ciclo.UbicacionInicio.temperatura
      );
      ciclo.UbicacionInicio.sensoresTemperatura.forEach(sensor => {
        sensor = fahrenheitToCelsius(sensor);
      });
      ciclo.UbicacionFin.temperatura = fahrenheitToCelsius(
        ciclo.UbicacionFin.temperatura
      );
      ciclo.UbicacionFin.sensoresTemperatura.forEach(sensor => {
        sensor = fahrenheitToCelsius(sensor);
      });
    });

    resultado.IntervalosFueraRango.forEach(intervalo => {
      intervalo.Rango.LimiteInferior = fahrenheitToCelsius(
        intervalo.Rango.LimiteInferior
      );
      intervalo.Rango.LimiteSuperior = fahrenheitToCelsius(
        intervalo.Rango.LimiteSuperior
      );
      intervalo.TemperaturaMinima = fahrenheitToCelsius(
        intervalo.TemperaturaMinima
      );
      intervalo.TemperaturaMaxima = fahrenheitToCelsius(
        intervalo.TemperaturaMaxima
      );
      intervalo.TemperaturaPromedio = fahrenheitToCelsius(
        intervalo.TemperaturaPromedio
      );
    });

    resultado.EventosTemp.forEach(evento => {
      evento.temperatura = fahrenheitToCelsius(evento.temperatura);
      evento.sensoresTemperatura.forEach(sensor => {
        sensor = fahrenheitToCelsius(sensor);
      });
    });

    resultado.Ubicaciones.forEach(ubicacion => {
      ubicacion.temperatura = fahrenheitToCelsius(ubicacion.temperatura);
      ubicacion.sensoresTemperatura.forEach(sensor => {
        sensor = fahrenheitToCelsius(sensor);
      });
    });
  });

  return temp;
};

export const celsiusToFahrenheit = temperature => {
  return Number(temperature * 1.8 + 32, -1).toFixed(1);
};

export const fahrenheitToCelsius = temperature => {
  return Number((temperature - 32) / 1.8).toFixed(1);
};



// WEBPACK FOOTER //
// ./src/utilities/temp.js